import React, { useState, useEffect } from "react";
import { getEmployeeList } from "../../services/apiService";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import "./ManualAttendanceEntry.css";
const API_BASE_URL = "https://alternative-lamprey-fatma-celik-a9c7fc96.koyeb.app";
const ManualAttendanceEntry = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [attendanceTime, setAttendanceTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchEmployees();

    // Varsayılan olarak şu anki saati ayarla
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    setAttendanceTime(`${hours}:${minutes}`);
  }, []);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const employeeList = await getEmployeeList();
      if (Array.isArray(employeeList)) {
        // Sadece aktif personelleri göster
        const activeEmployees = employeeList.filter((emp) => emp.is_active);
        setEmployees(activeEmployees);
      }
    } catch (err) {
      console.error("Personel listesi yüklenemedi:", err);
      setError("Personel listesi yüklenemedi");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e, attendanceType) => {
    e.preventDefault();

    if (!selectedEmployee) {
      setError("Lütfen bir personel seçin");
      return;
    }

    if (!attendanceTime) {
      setError("Lütfen bir saat girin");
      return;
    }

    setSubmitting(true);
    setError("");
    setSuccess("");

    try {
      // Seçilen personelin bilgilerini al
      const selectedEmployeeData = employees.find(
        (emp) => emp.user_id === parseInt(selectedEmployee)
      );

      if (!selectedEmployeeData || !selectedEmployeeData.rfid_tag) {
        setError("Personel RFID bilgisi bulunamadı");
        return;
      }

      // Yerel saat bilgisini zaman dilimi ile birlikte oluştur
      const now = new Date();
      const [hours, minutes] = attendanceTime.split(":");

      // Yeni bir tarih nesnesi oluştur (bugünün tarihini kullan)
      const localDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        parseInt(hours),
        parseInt(minutes)
      );

      // Zaman dilimi ofsetini hesapla (dakika cinsinden)
      const timezoneOffset = -localDate.getTimezoneOffset(); // Negatif işaret düzeltmesi
      const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
      const offsetMinutes = Math.abs(timezoneOffset) % 60;
      const offsetSign = timezoneOffset >= 0 ? "+" : "-";

      // Zaman dilimi bilgisini formatla (+03:00 gibi)
      const timezoneString = `${offsetSign}${String(offsetHours).padStart(
        2,
        "0"
      )}:${String(offsetMinutes).padStart(2, "0")}`;

      // ISO formatında saat bilgisini oluştur (zaman dilimi ile birlikte)
      const isoString = `${localDate.getFullYear()}-${String(
        localDate.getMonth() + 1
      ).padStart(2, "0")}-${String(localDate.getDate()).padStart(
        2,
        "0"
      )}T${attendanceTime}:00${timezoneString}`;

      // access_logs endpoint'ine istek at
      const token = localStorage.getItem("jwt_token");
      const response = await fetch(`${API_BASE_URL}/api/access-logs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          rfid_tag: selectedEmployeeData.rfid_tag,
          user_id: parseInt(selectedEmployee),
          access_type: attendanceType,
          access_time: isoString, // Zaman dilimi bilgisi eklenmiş ISO string
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess(
          `${
            attendanceType === "IN" ? "Giriş" : "Çıkış"
          } kaydı başarıyla oluşturuldu`
        );
        // Formu sıfırla
        setSelectedEmployee("");

        // Varsayılan olarak şu anki saati güncelle
        const newNow = new Date();
        const newHours = String(newNow.getHours()).padStart(2, "0");
        const newMinutes = String(newNow.getMinutes()).padStart(2, "0");
        setAttendanceTime(`${newHours}:${newMinutes}`);
      } else {
        setError(result.error || "İşlem başarısız oldu");
      }
    } catch (err) {
      console.error("Attendance kaydı hatası:", err);
      setError(err.message || "Sunucu hatası, lütfen tekrar deneyin");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="manual-attendance-loading">
        <OrbitLoaderComponent size="small" showPath={true} />
        <p>Personel listesi yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="manual-attendance-entry">
      <div className="manual-attendance-header">
        <h3 className="manual-attendance-title">
          <i className="fas fa-user-clock"></i>
          Manuel Personel Giriş/Çıkış
        </h3>
      </div>

      {error && (
        <div className="manual-attendance-error">
          <i className="fas fa-exclamation-circle"></i>
          {error}
        </div>
      )}

      {success && (
        <div className="manual-attendance-success">
          <i className="fas fa-check-circle"></i>
          {success}
        </div>
      )}

      <form className="manual-attendance-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="employee-select">Personel Seçin</label>
            <div className="select-wrapper">
              <select
                id="employee-select"
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
                disabled={submitting}
              >
                <option value="">Personel seçin...</option>
                {employees.map((employee) => (
                  <option key={employee.user_id} value={employee.user_id}>
                    {employee.name} {employee.surname} - {employee.role_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="time-input">Saat</label>
            <div className="time-input-wrapper">
              <input
                type="time"
                id="time-input"
                value={attendanceTime}
                onChange={(e) => setAttendanceTime(e.target.value)}
                disabled={submitting}
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="manual-attendance-btn manual-attendance-btn-in"
            onClick={(e) => handleSubmit(e, "IN")}
            disabled={submitting || !selectedEmployee || !attendanceTime}
          >
            {submitting ? (
              <>
                <OrbitLoaderComponent size="x-small" showPath={false} />
                <span>Kaydediliyor...</span>
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                <span>Giriş Yap</span>
              </>
            )}
          </button>

          <button
            type="button"
            className="manual-attendance-btn manual-attendance-btn-out"
            onClick={(e) => handleSubmit(e, "OUT")}
            disabled={submitting || !selectedEmployee || !attendanceTime}
          >
            {submitting ? (
              <>
                <OrbitLoaderComponent size="x-small" showPath={false} />
                <span>Kaydediliyor...</span>
              </>
            ) : (
              <>
                <i className="fas fa-sign-out-alt"></i>
                <span>Çıkış Yap</span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ManualAttendanceEntry;
